import React, { FC } from "react";
import styles from "./close-master-create-study-modal.module.scss";
import Button from "../../../ui-kit/button/button";
import Modal from "../../../../shared/modal/modal";
import { useTranslation } from "react-i18next";

interface CloseMasterCreateStudyModalProps {
  onReturn: () => void;
  onConfirm: () => void;
}

const CloseMasterCreateStudyModal: FC<CloseMasterCreateStudyModalProps> = ({
  onReturn,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Modal onClose={onReturn} showCloseBtn={false}>
      <div className={styles.modalCloseMasterPlan}>
        <div className={styles.body}>
          <span className={styles.title}>
            {t("master-create-study.modalCloseMaster.title")}
          </span>
          <p className={styles.description}>
            {t("master-create-study.modalCloseMaster.description")}
          </p>
        </div>
        <div className={styles.buttonSection}>
          <Button
            onClick={onReturn}
            className={styles.returnBtn}
            type="primary"
          >
            {t("master-create-study.modalCloseMaster.returnBtn")}
          </Button>
          <Button
            onClick={onConfirm}
            className={styles.closeBtn}
            type="outline"
          >
            {t("master-create-study.modalCloseMaster.closeBtn")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CloseMasterCreateStudyModal;
